import { dateUtils } from '@festina-life/core'
import { useTranslate } from '@festina-life/ui/hooks'
import dayjs from 'dayjs'

import type { ParameterValueRowData } from './types'

type Props = {
  data: ParameterValueRowData
  column: number
  row?: number
}

export const ParameterValueCell = ({ data, column }: Props) => {
  const translate = useTranslate()

  switch (column) {
    case 0: {
      const from =
        data.interval.from !== Number.NEGATIVE_INFINITY
          ? dateUtils.dateAsStr(dayjs(data.interval.from).local().toDate())
          : ''
      const to =
        data.interval.to !== Number.POSITIVE_INFINITY
          ? dateUtils.dateAsStr(dayjs(data.interval.to).local().toDate())
          : ''
      const intervalValue = from || to ? `${from} - ${to}` : translate('none')

      return <div className="px-4">{!data.isGrouped ? intervalValue : ''}</div>
    }
    case data.dimensions.length + 1:
      return (
        <div className="p-2">
          {Array.isArray(data.value) ? data.value.join(', ') : data.value}
        </div>
      )
    default:
      return (
        <div>
          {data.dimensions.at(column - 1)?.value === null
            ? translate('parameterViewer.values.anyValue')
            : (data.dimensions.at(column - 1)?.value ?? '')}
        </div>
      )
  }
}
